module.exports = __webpack_public_path__ + "img/武汉科技大学.abcbe1ae.png";